import { render, staticRenderFns } from "./tab-user.vue?vue&type=template&id=4b8d95b9&scoped=true"
import script from "./tab-user.vue?vue&type=script&lang=js"
export * from "./tab-user.vue?vue&type=script&lang=js"
import style0 from "./tab-user.vue?vue&type=style&index=0&id=4b8d95b9&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b8d95b9",
  null
  
)

export default component.exports